import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'

import MarkdownComponents from "components/markdown/MarkdownComponents"

const YesIcon = () => (
    <svg width="21" height="21" viewBox="0 0 64 64" style={{ display: 'inline-block', verticalAlign: 'middle', marginBottom: '4px', marginRight: "2px" }} xmlns="http://www.w3.org/2000/svg">
        <path d="M28.2666 36.7999L22.5333 31.0666C22.0444 30.5777 21.4221 30.3333 20.6666 30.3333C19.911 30.3333 19.2888 30.5777 18.7999 31.0666C18.311 31.5555 18.0666 32.1777 18.0666 32.9333C18.0666 33.6888 18.311 34.311 18.7999 34.7999L26.3999 42.3999C26.9333 42.9333 27.5555 43.1999 28.2666 43.1999C28.9777 43.1999 29.5999 42.9333 30.1333 42.3999L45.1999 27.3333C45.6888 26.8444 45.9333 26.2221 45.9333 25.4666C45.9333 24.711 45.6888 24.0888 45.1999 23.5999C44.711 23.111 44.0888 22.8666 43.3333 22.8666C42.5777 22.8666 41.9555 23.111 41.4666 23.5999L28.2666 36.7999ZM31.9999 58.6666C28.311 58.6666 24.8444 57.9661 21.5999 56.5653C18.3555 55.1644 15.5333 53.2648 13.1333 50.8666C10.7333 48.4684 8.8337 45.6461 7.43459 42.3999C6.03548 39.1537 5.33503 35.687 5.33326 31.9999C5.33148 28.3128 6.03192 24.8461 7.43459 21.5999C8.83726 18.3537 10.7368 15.5315 13.1333 13.1333C15.5297 10.735 18.3519 8.83547 21.5999 7.43459C24.8479 6.0337 28.3146 5.33325 31.9999 5.33325C35.6853 5.33325 39.1519 6.0337 42.3999 7.43459C45.6479 8.83547 48.4701 10.735 50.8666 13.1333C53.263 15.5315 55.1635 18.3537 56.5679 21.5999C57.9724 24.8461 58.6719 28.3128 58.6666 31.9999C58.6613 35.687 57.9608 39.1537 56.5653 42.3999C55.1697 45.6461 53.2701 48.4684 50.8666 50.8666C48.463 53.2648 45.6408 55.1653 42.3999 56.5679C39.159 57.9706 35.6924 58.6701 31.9999 58.6666Z" fill="var(--accent)" />
    </svg>
);

const NoIcon = () => (
    <svg width="21" height="21" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block', verticalAlign: 'middle', marginBottom: '5px', marginRight: "2px" }}>
        <mask id="mask0_2252_2" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="5" y="5" width="54" height="54">
            <path d="M32 8C45.2533 8 56 18.7467 56 32C56 45.2533 45.2533 56 32 56C18.7467 56 8 45.2533 8 32C8 18.7467 18.7467 8 32 8Z" fill="white" stroke="white" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M31.9999 31.9999L42.6666 42.6666M31.9999 31.9999L21.3333 21.3333M31.9999 31.9999L21.3333 42.6666M31.9999 31.9999L42.6666 21.3333" stroke="black" strokeWidth="5.33333" strokeLinecap="round" strokeLinejoin="round" />
        </mask>
        <g mask="url(#mask0_2252_2)">
            <path d="M64 0H0V64H64V0Z" fill="var(--warning)" />
        </g>
    </svg>
);


export default function MarkdownRenderer({ content }) {
    const replacedContent = content
        // ── self-closing ──────────────────────────────────────────────
        .replace(/<Yes\s*\/\s*>/gi, '<span class="h-min inline-block"><yes-icon /></span>')
        .replace(/<No\s*\/\s*>/gi, '<span class="h-min inline-block"><no-icon  /></span>')

        // ── opening + closing ─────────────────────────────────────────
        .replace(/<Yes\s*>([\s\S]*?)<\/\s*Yes\s*>/gi, (_, inner) =>
            `<span class="h-min inline-block"><yes-icon /></span><span class="md_AccentText ml-1">${inner.trim()}</span>`
        )
        .replace(/<No\s*>([\s\S]*?)<\/\s*No\s*>/gi, (_, inner) =>
            `<span class="h-min inline-block"><no-icon  /></span><span class="md_WarningText ml-1">${inner.trim()}</span>`
        )
    // .replace(/a/g, "AAAAAADSASADAS")
    // Replace 4 spaces with a non-breaking space span
    // .replace(/```\s*([\w-]*)\s*([\s\S]*?)\s*```/g, (_, lang, code) => {
    //     const knownLangs = ["python", "js", "javascript", "html", "css", "java", "c", "cpp", "bash", "sh"];
    //     if (knownLangs.includes(lang.toLowerCase())) {
    //         // Strip known language
    //         console.log("Code block with known lang:", lang, code);
    //         return `<pre>${code.trim()}</pre>`;
    //     } else {
    //         // Treat as no language
    //         console.log("Code block with unknown/no lang:", lang, code);
    //         return `<pre>${lang} ${code.trim()}</pre>`;
    //     }
    // });

    return (
        <div className='_MarkdownRenderer'>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                    ...MarkdownComponents,
                    'yes-icon': () => <YesIcon />,
                    'no-icon': () => <NoIcon />,
                    small: ({ children }) => <span className="text-sm text-text-light font-bold">{children}</span>,
                    indent: ({ children }) => <span className="pl-3 inline-block">{children}</span>,
                }}
            >
                {replacedContent}
            </ReactMarkdown>
        </div>
    )
}